// extracted by mini-css-extract-plugin
export var base = "_4q-0";
export var updateBanner = "_4q-1";